import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDocker } from '@fortawesome/free-brands-svg-icons';
import { faBrain, faPlug } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Python",
    "Java",
    "SQL",
    "Git",
    "Docker",
    "REST APIs"
];

const labelsSecond = [
    "Pandas",
    "NumPy",
    "Matplotlib",
    "Seaborn",
    "TensorFlow",
    "PyTorch",
    "Keras",
    "Scikit-learn"
];

const labelsThird = [
    "Generative AI",
    "GPT-4",
    "Llama",
    "Gemini",
    "Prompt Engineering",
    "RAG",
    "Finetuning",
    "LangChain",
    "LlamaIndex",
    "Hugging Face",
    "AWS (S3, SageMaker)",
    "GCP (Vertex AI)"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faBrain} size="3x"/>
                    <h3>Languages & Tools</h3>
                    <p>Proficient in building backend logic, manipulating databases, managing version control, and orchestrating containers using modern SDE patterns.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPlug} size="3x"/>
                    <h3>AI & ML Frameworks</h3>
                    <p>Experienced in training architectures, performing data science exploration, and implementing statistical and neural network pipelines.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Generative AI & Cloud</h3>
                    <p>Specialized in deploying RAG systems, tuning LLMs, prompt engineering, and managing models in AWS SageMaker and GCP Vertex AI environments.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;